import { isDefined } from '@sgme/fp';
import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';

import {
  useCheckTargetAccumulatorByTradeCapture,
  useTargetAccumulatorSelector,
  useTargetAccumulatorTileId,
} from '@/App/tiles/TargetAccumulator/TargetAccumulatorContext.tsx';
import { TargetAccumulatorFormField } from '@/App/tiles/TargetAccumulator/TargetAccumulatorFormField.tsx';
import { SgNumberInput } from '@/components/sg-design-system/components/input/SgNumberInput';
import { TradeCaptureValidationWrapper } from '@/components/ui/TradeCaptureFieldErrorWrapper.tsx';
import { useAppSelector } from '@/store/hooks.ts';
import {
  selectTargetAccumulatorRfsSpotHedge,
  selectTargetAccumulatorValidation,
} from '@/store/targetAccumulator/selectors.ts';

export function SpotRef() {
  const tileId = useTargetAccumulatorTileId();

  const { sgwtWebAnalytics } = useSgwtWidgets();
  const checkTargetAccumulatorWithTradeCapture = useCheckTargetAccumulatorByTradeCapture();
  const hedgeType = useTargetAccumulatorSelector((targetAccumulator) => targetAccumulator?.properties.hedgeType);
  const hedgeSpotPrice = useTargetAccumulatorSelector((targetAccumulator) => targetAccumulator?.properties.spotHedge);

  const validation = useAppSelector((state) => selectTargetAccumulatorValidation(state, tileId));
  const rfsHedgeSpotPrice = useTargetAccumulatorSelector((targetAccumulator) =>
    selectTargetAccumulatorRfsSpotHedge(targetAccumulator),
  );

  const isPinned = isDefined(hedgeSpotPrice);

  function handleChange(hedgeSpot: number | undefined | null) {
    sgwtWebAnalytics?.trackEvent('TargetAccumulator', 'SpotForward ref change', String(hedgeSpot));

    return checkTargetAccumulatorWithTradeCapture({
      spotHedge: hedgeSpot,
    });
  }

  if (hedgeType === 'Live') {
    return null;
  }

  return (
    <TargetAccumulatorFormField formattedMessageId="targetAccumulator.form.SpotRef">
      <div className="d-flex px-1">
        <TradeCaptureValidationWrapper validation={validation?.spotHedge}>
          <SgNumberInput
            valuePosition="start"
            size="sm"
            onChange={handleChange}
            className={isPinned ? 'text-info fw-bold ' : undefined}
            data-e2e="spotRef"
            acceleratorsEnabled
            value={
              isDefined(hedgeSpotPrice)
                ? Number(hedgeSpotPrice)
                : isDefined(rfsHedgeSpotPrice)
                  ? Number(rfsHedgeSpotPrice)
                  : undefined
            }
          />
        </TradeCaptureValidationWrapper>
        {isPinned && (
          <button
            onClick={() => handleChange(null)}
            type="button"
            className="btn btn-sm btn-icon btn-flat-primary"
            data-e2e="spotRef-pin"
          >
            <em className="icon icon-sm cursor-default line-height-1 text-secondary">push_pin</em>
          </button>
        )}
      </div>
    </TargetAccumulatorFormField>
  );
}
